export const getAccessToken = function() {
    const obj = JSON.parse(window.sessionStorage.getItem("authUser"));
    return (obj && obj.token) ? obj.token : "";
}

const accessToken = getAccessToken()
console.log()
export default {accessToken, getAccessToken};